/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Choice } from './Choice';
import {
    ChoiceFromJSON,
    ChoiceFromJSONTyped,
    ChoiceToJSON,
} from './Choice';
import type { Denotation } from './Denotation';
import {
    DenotationFromJSON,
    DenotationFromJSONTyped,
    DenotationToJSON,
} from './Denotation';
import type { Item } from './Item';
import {
    ItemFromJSON,
    ItemFromJSONTyped,
    ItemToJSON,
} from './Item';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';
import type { ValueInfo } from './ValueInfo';
import {
    ValueInfoFromJSON,
    ValueInfoFromJSONTyped,
    ValueInfoToJSON,
} from './ValueInfo';

/**
 * Optional list of property values [used by: PropertiesListing, Tracking]
 * @export
 * @interface Value
 */
export interface Value {
    /**
     * 
     * @type {string}
     * @memberof Value
     */
    id: string;
    /**
     * 
     * @type {Array<Message>}
     * @memberof Value
     */
    messages?: Array<Message>;
    /**
     * 
     * @type {Choice}
     * @memberof Value
     */
    choice?: Choice;
    /**
     * 
     * @type {Denotation}
     * @memberof Value
     */
    helpInfo?: Denotation;
    /**
     * 
     * @type {ValueInfo}
     * @memberof Value
     */
    info?: ValueInfo;
    /**
     * 
     * @type {Item}
     * @memberof Value
     */
    item?: Item;
    /**
     * Set for trigger properties on server roundtrip, if true the user did edit this value, if false the server roundtrip is for another reason
     * @type {boolean}
     * @memberof Value
     */
    triggerCause?: boolean;
}

/**
 * Check if a given object implements the Value interface.
 */
export function instanceOfValue(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function ValueFromJSON(json: any): Value {
    return ValueFromJSONTyped(json, false);
}

export function ValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): Value {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'messages': !exists(json, 'messages') ? undefined : ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'choice': !exists(json, 'choice') ? undefined : ChoiceFromJSON(json['choice']),
        'helpInfo': !exists(json, 'helpInfo') ? undefined : DenotationFromJSON(json['helpInfo']),
        'info': !exists(json, 'info') ? undefined : ValueInfoFromJSON(json['info']),
        'item': !exists(json, 'item') ? undefined : ItemFromJSON(json['item']),
        'triggerCause': !exists(json, 'triggerCause') ? undefined : json['triggerCause'],
    };
}

export function ValueToJSON(value?: Value | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'messages': value.messages === undefined ? undefined : ((value.messages as Array<any>).map(MessageToJSON)),
        'choice': ChoiceToJSON(value.choice),
        'helpInfo': DenotationToJSON(value.helpInfo),
        'info': ValueInfoToJSON(value.info),
        'item': ItemToJSON(value.item),
        'triggerCause': value.triggerCause,
    };
}

